import { render, staticRenderFns } from "./previewImage.vue?vue&type=template&id=c8627736&scoped=true"
import script from "./previewImage.vue?vue&type=script&lang=js"
export * from "./previewImage.vue?vue&type=script&lang=js"
import style0 from "./previewImage.vue?vue&type=style&index=0&id=c8627736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8627736",
  null
  
)

export default component.exports